import { createBrowserClient } from '@supabase/ssr';
import { getSupabaseCookieOptions } from './cookieOptions';

let browserClient: ReturnType<typeof createBrowserClient> | null = null;

export function createClient() {
  if (!browserClient) {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;
    browserClient = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        cookieOptions: getSupabaseCookieOptions(hostname),
      }
    );
  }

  return browserClient;
}
